import React from "react";
import SettlementRequestsBySupplier from "../../supplierPayment/settlementRequestsBySupplier";


export default function SettlementRequest() {

    return (
        <div>

            <SettlementRequestsBySupplier />
        </div>
    );

}
